export default [
  {
    path: '/clientes',
    name: 'Clientes',
    component: () => import(/* webpackChunkName: "Clientes" */ '../clientes/Clientes')
  },
  {
    path: '/clientes-cadastro',
    name: 'ClientesCadastro',
    component: () => import(/* webpackChunkName: "ClientesCadastro" */ '../clientes/ClientesCadastro')
  },
  {
    path: '/clientes-lista',
    name: 'ClientesLista',
    component: () => import(/* webpackChunkName: "ClientesLista" */ '../clientes/ClientesLista')
  }
]



// WEBPACK FOOTER //
// ./src/pages/clientes/router.js